import Carousel from "@/design-system/carousel";
import { useViewportInfoContext } from "@/src/contexts";
import type { IFlyerTabResources } from "@/src/flyers/FlyersTabResources.Resources";
import Text from "@Components/Text";
import * as stylex from "@stylexjs/stylex";

import { type QueryXsMax, colors } from "../../styles/tokens.stylex";
import type { IMostPopularFlyersItem } from "./MostPopularFlyersItem";
import { MostPopularFlyersItem } from "./MostPopularFlyersItem";

export interface IMostPopularFlyersSlider {
    resources: IFlyerTabResources["mostPopularFlyers"];
    data?: IMostPopularFlyersItem[];
}

export default function MostPopularFlyersSlider(props: IMostPopularFlyersSlider) {
    const { isMobile, isLaptop, isTablet } = useViewportInfoContext();

    return (
        <>
            <Text textElement="h1" fontWeight="400" fontStyle="h3" styleX={styles.title}>
                {props.resources.title}
            </Text>
            {props.data?.length ? (
                <Carousel
                    itemsToShow={isMobile ? 2.2 : isTablet ? 3 : isLaptop ? 4 : 5}
                    showArrows={!isMobile}
                    carouselContainerStyleX={styles.carouselOverride}
                    arrowStyleX={styles.arrowsOverride}
                >
                    {props.data.map((item, index) => (
                        <MostPopularFlyersItem key={index} {...item} />
                    ))}
                </Carousel>
            ) : null}
        </>
    );
}

const xsMax: QueryXsMax = "@media (max-width: 759px)";

const styles = stylex.create({
    title: {
        padding: { default: "0 0 40px", [xsMax]: "0 0 30px 20px" },
        color: colors.grayDark,
        textTransform: "uppercase",
    },

    carouselOverride: {
        paddingBlock: "0",
        paddingInline: "25px",
        scrollSnapType: "x mandatory",
    },

    arrowsOverride: {
        color: colors.grayDark,
        height: "30px",
        width: "30px",
    },
});
